import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import "./ReportModal.css"; // Custom CSS for your styling

const ReportModal = ({ open, onClose, report }) => {
  if (!report) {
    // If there's no report yet, just return null or a skeleton
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle className="report-modal-title">Session Report</DialogTitle>
      <DialogContent className="report-modal-content">
        {/* Strength Points */}
        <Box className="report-section">
          <Typography variant="subtitle1" className="report-label">
            Strength Points:
          </Typography>
          <Typography variant="body1" className="report-text">
            {report.strength_points || "N/A"}
          </Typography>
        </Box>

        {/* Points to Improve */}
        <Box className="report-section">
          <Typography variant="subtitle1" className="report-label">
            Points to Improve:
          </Typography>
          <Typography variant="body1" className="report-text">
            {report.points_to_improve || "N/A"}
          </Typography>
        </Box>

        {/* Recommendation */}
        <Box className="report-section">
          <Typography variant="subtitle1" className="report-label">
            Recommendation:
          </Typography>
          <Typography variant="body1" className="report-text">
            {report.recommendation || "N/A"}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} className="report-modal-close-button">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ReportModal;
